<script>
import { mapState } from "vuex";
import MultiSelect from "@/components/MultiSelect";

export default {
  props: {
    // Id of the modal, for v-b-modal.the-id
    modalId: {
      type: String,
      default: "fullscreen-modal",
    },
  },

  components: {
    MultiSelect,
  },

  data() {
    return {
      selectedTeams: [],
    };
  },

  computed: {
    // Mapped state
    ...mapState(["teams"]),
  },

  methods: {
    // Search for multiselect
    teamMatchesSearch(search, team) {
      search = search.trim().toLowerCase();
      let team_handle = team.handle;
      return team_handle.toLowerCase().includes(search);
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Enter full screen submit
    submit() {
      this.hide();
      this.$router.push({
        name: "fullscreen",
        params: { teams: this.selectedTeams },
      });
    },
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Enter Full-Screen"
    button-size="sm"
    hide-header-close
  >
    <p>
      You are about to enter full-screen mode. Please keep in mind that
      full-screen is best used with a large display. The view will also have
      minimal interactivity.
    </p>
    <br />
    <p>Select the teams that you would like to monitor in full screen:</p>
    <MultiSelect
      :max="20"
      :options="this.teams"
      :match="teamMatchesSearch"
      v-model="selectedTeams"
    />
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button variant="success" @click="submit">Enter Fullscreen</b-button>
      </div>
    </template>
  </b-modal>
</template>
